import React from 'react';
import { SvgIcon } from '../svg-icon';

export const ArrowRightCircle = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12ZM14.3167 12.5556H7.55555V11.4444L14.3167 11.4444L11.2167 8.33888L12 7.55555L16.4444 12L12 16.4444L11.2111 15.6611L14.3167 12.5556Z" />
  </SvgIcon>
);
